import { render, staticRenderFns } from "./cards-funcionarios.vue?vue&type=template&id=1e4bfa6c&scoped=true"
var script = {}
import style0 from "./cards-funcionarios.vue?vue&type=style&index=0&id=1e4bfa6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4bfa6c",
  null
  
)

export default component.exports